import {Injectable, Injector} from '@angular/core';
import {CoreSharedApiBaseService, Product} from '@app/core-shared';

@Injectable()
export class CorePortalInvitationsContactService extends CoreSharedApiBaseService {
  constructor(
    protected injector: Injector
  ) {
    super(injector, Product.TECH, 'contact', ['v2/invitation']);
  }
}
